import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  products: []
}

const mutations = {  
  SET_PRODUCTS (state, payload) {
    state.products = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  productList: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&_id[]=${element}`
      }
    }
    return Vue.http.get(`${env.API}/api/product${query}`)    
      .then((response) => {        
        context.commit('SET_PRODUCTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  productSelectList: (context, data) => {
    return Vue.http.get(`${env.API}/api/product/select-list`)    
      .then((response) => {        
        context.commit('SET_PRODUCTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  BySegmentId: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&_id[]=${element}`
      }
    }

    return Vue.http.get(`${env.API}/api/product/segment/${data.segment}${query}`)    
      .then((response) => {        
        context.commit('SET_PRODUCTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  BySegmentIds: (context, data) => {
    return Vue.http.get(`${env.API}/api/product/segments/${data.segments}`)
      .then((response) => {
        context.commit('SET_PRODUCTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getProductById: (context, id) => {
    if (id == undefined) {
      return null
    } else {
      return Vue.http.get(`${env.API}/api/product/by-id/${id}`)    
        .then((response) => {                
          return response.body.message
        })
        .catch((error) => {
          return context.commit('API_FAILURE', error)
        })
    }
  },
  getProductByRoles: (context, ids) => {
    return Vue.http.post(`${env.API}/api/product/by-roles`, ids)    
      .then((response) => {
        context.commit('SET_PRODUCTS', response.body.message)              
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getProducts: (state) => state.products
}

export const product = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js